import { memo, ReactNode } from "react";
import { BaseSnackbarTemplateProps } from "./types";

export type CustomSnackbarTemplateProps = BaseSnackbarTemplateProps & {
  type?: "custom",
  render: (props: Omit<CustomSnackbarTemplateProps, "type" | "render">) => ReactNode
};

export const CustomSnackbarTemplate = memo<CustomSnackbarTemplateProps>(({ render, ...restProps }) => {
  return (
    <>
      {render({ ...restProps })}
    </>
  );
});

export default CustomSnackbarTemplate;